export default {
    url: '',
    template: '<forms-questions-pools-list></forms-questions-pools-list>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/pools/list/index.js